import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { ScreenText } from '@/lang/ScreenText';
import { PrintPayload } from '@/Model/model';
import DashboardPrintComponent from '@/components/datadashboardprintcomponent/DashboardPrintComponent.vue';
import LineQualityChart from '../../chartcomponents/linequalitycomponent/LineQualityComponent.vue';
import LineChart from '../../chartcomponents/linecomponent/LineComponent.vue';
import BarChart from '../../chartcomponents/barcomponent/BarComponent.vue';
import DoughnutChart from '../../chartcomponents/doughnutcomponent/DoughnutComponent.vue';
import testChart from '../../chartcomponents/testComponent/testComponent.vue';
import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { getRetention, getQualityData, getAssementQualityData, getRetentionBySite, getAda, getAdaBySite, getRecruitmentData, printHTMLTOPdf } from '@/services/dashboard/dashboardService';
import { getSiteByProgramId } from '@/services/create-user/createUserService';
import html2canvas from 'html2canvas';
import DataDashboardSidepanel from './datadashboardsidepanel/DataDashboardSidepanel.vue';
import leftSidepanel from '@/popupcomponents/leftsidepanel/leftSidepanel.vue';
import UIkit from 'uikit';
import programConfigureStore from '@/store/modules/programConfigure';
import qualityScoreView from '@/popupcomponents/qualityScoreView/qualityScoreView.vue';
import LocalStorage from '@/utilities/localStorageUtil';

import Printutility from '@/utilities/PrintComponentMethod';
@Component({
  components: {
    'dashboard-print': DashboardPrintComponent,
    'LineQualityChart': LineQualityChart,
    'LineChart': LineChart,
    'DoughnutChart': DoughnutChart,
    'BarChart': BarChart,
    'chart': testChart,
    'sidepanelMobile': leftSidepanel,
    'sidepanelDesktop': DataDashboardSidepanel,
    'quality-score-view': qualityScoreView
  }
})
export default class DataDashboardComponent extends Vue {

  pageViewsByCategory: [] = [];
  pageViews: [] = [];
  adaData: [] = [];
  lineChartDataFormat: any = [];
  mobilelineChartDataFormat: any = [];
  barChartDataFormat: any = [];
  mobilebarChartDataFormat: any = [];
  slicedLineChartDataFormat: any = [];
  slicedBarChartDataFormat: any = [];
  mobileSlicedBarChartDataFormat: any = [];
  tabs: any[] = JSON.parse(JSON.stringify(APP_CONST.TAB_SELECTION));
  TabIndex: number = 0;
  siteList: any[] = [];
  openSiteDrop: boolean = false;
  openRetetionDrop: boolean = false;
  selectedSite: string = 'All Sites';
  selectedSiteId: number = 0;
  mobileView: boolean = false;
  mobileSelectedSite: string = 'All Sites';
  selectedFilterTab: number = 0;
  selectedFilterTabForAda: number = 0;
  selectedTab: string = 'ada';
  retLineSliceStart: number = 0;
  retLineSliceEnd: number = this.getWindowWidth()
    ? 5
    : 8;
  retBarSliceStart: number = 0;
  retBarSliceEnd: number = this.getWindowWidth()
    ? 5
    : 8;
  adaLineSliceStart: number = 0;
  adaLineSliceEnd: number = this.getWindowWidth()
    ? 5
    : 8;
  adaBarSliceStart: number = 0;
  adaBarSliceEnd: number = this.getWindowWidth()
    ? 5
    : 8;
  adaBarTotal: number = 0;
  adaLineTotal: number = 0;
  retLineTotal: number = 0;
  retBarTotal: number = 0;
  WeekEndDate: any = '';
  public siteId: number = 0;
  openADARetetionDrop: boolean = false;
  attandancePercentage: any = '--';
  mobileAttandancePercentage: any = '--';
  isSelectionFromMobile: any = false;
  weekDates: any = [];
  windowWidth: number = 768;
  public scholarRetentionData: any = [];
  public hoverStyleObj: any = {};
  public userRoles: any = [];
  public programId: number = 0;
  public lineChartMessage: boolean = false;
  public mobileLineChartMessage: boolean = false;
  public barChartMessage: boolean = false;
  public barChartMessageForRet: boolean = false;
  public disablePrintBtn: boolean = false;
  public emptyState: boolean = false;
  public renderPrintKey: any = {
    chart1: 0,
    chart2: 0,
    index: 0
  };
  public hover: boolean = false;
  public hoverIndex: string = '';
  private objScreenText: ScreenText = new ScreenText();
  public styles: any = {
    width: '100%',
    height: '325px',
    position: 'relative'
  };
  public doughnutStyle: any = {
    width: '180px',
    height: '180px',
    margin: '0 auto'
  };
  public MobiledoughnutStyle: any = {
    width: '116px',
    height: '116px',
    margin: '0 auto'
  };
  public barStyle: any = {
    width: '100%',
    height: '325px'
  };
  public dataloaded: boolean = false;
  public emptyDataMobile: any = [{ 'week': 1, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.7, 'score': 'N/A', 'endDate': 'N/A' }];
  public emptyData: any = [{ 'week': 1, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 1.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 2.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 3.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 4.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 4.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 4.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 4.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 4.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 4.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 5.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 5.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 5.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 5.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 5.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 5.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 6.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 6.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 6.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 6.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 6.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 6.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 7.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 7.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 7.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 7.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 7.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 7.7, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 8, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 8.2, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 8.3, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 8.4, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 8.5, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 8.6, 'score': 'N/A', 'endDate': 'N/A' }, { 'week': 8.7, 'score': 'N/A', 'endDate': 'N/A' }];

  public attendanceData: any = [{ week: 1, data: 95 }, { week: 2, data: 45 }, { week: 3, data: 85 }, { week: 4, data: 70 }, { week: 5, data: 65 }, { week: 6, data: 85 }, { week: 7, data: 75 }, { week: 8, data: 70 }, { week: 9, data: 85 }, { week: 10, data: 75 }, { week: 11, data: 70 }, { week: '' }];
  public doughnutDataFormat: any = {};
  public doughnutPercentageFormat: any = {};
  public sch_recr_percentage: any = {};
  public sch_recr_data: any = {};
  public showSidepanel: boolean = false;
  private hoverOut: boolean = false;
  private hoverVal: string = '';
  public siteData: any = [];
  scholarGraph: boolean = true;
  doughnutChartText: string = 'Enrolled';
  doughnutChartTextValue: string = 'Enrolled';
  activeLeftPanelTab: string = '';
  qualityGraphData: any = [];
  allQualityGraphData: any = [];
  qualityAverageScore: any = '--';
  private siteSelected: any = [];

  qualityLineSliceStart: number = 0;
  qualityLineSliceEnd: number = this.getWindowWidth()
    ? 3
    : 8;
  qualityLineTotal: number = 0;
  updateQualityDashboard: boolean = false;
  isPdfPrintInProgress: boolean = false;
  hidequalityScore: boolean = false;
  hideAnnotation: boolean = true;
  hideQualityAnnotation: boolean = true;
  hideBarAnnotation: boolean = true;

  @Prop()
  userDetails!: any;

  @Prop()
  roleId!: number;

  @Watch('userDetails', { deep: true, immediate: true })
  getSiteList(data: any) {
    /* istanbul ignore else */
    if (this.programId != data.programId) {
      const programId = data.programId
        ? data.programId
        : APP_UTILITIES.getCookie('programId');
      this.programId = data.programId
        ? data.programId
        : APP_UTILITIES.getCookie('programId');
      this.fetchAccountDetails(programId);
      this.getSite(programId);

    }
  }

  handlePrintComp(e: any) {
    this.renderPrintKey[e.type] = e.index;
  }
  fetchAccountDetails(programId: string): any {
    programConfigureStore.getProgramConfigObjProgramPage(parseInt(programId)).then(response => {
      const responseData: any = ((<any>response).data === undefined)
        ? null
        : (<any>response).data;
      this.userDetails.programStartDate = responseData.programDto.startDate
        ? responseData.programDto.startDate
        : this.userDetails.programStartDate;
      this.userDetails.programEndDate = responseData.programDto.endDate
        ? responseData.programDto.endDate
        : this.userDetails.programEndDate;
    });
  }
  printDashboard() {
    const base64Array: any = [];
    let currentDate = APP_UTILITIES.getSlashedDates(new Date());
    currentDate = currentDate.replace(/-/g, '_');
    setTimeout(() => {
      /* istanbul ignore if */
      if (!this.disablePrintBtn) {
        this.disablePrintBtn = true;
        const el = document.getElementById('dashboardPrintContainer') as HTMLElement;
        html2canvas(el, {
          width: 1375,
          height: 1000,
        }).then((canvas: any) => {
          /* istanbul ignore next */
          const byteData = canvas.toDataURL('image/jpeg', 1);
          base64Array.push(byteData);
          const dataToSend: PrintPayload = {
            base64Data: base64Array,
            landscape: true,
            outputFilename: 'Scholar Data Dashboard'
          };
          /* istanbul ignore next */
          printHTMLTOPdf(dataToSend).then((res: any) => {
            if (res.status === APP_CONST.RESPONSE_200) {
              this.disablePrintBtn = false;
              const bufferArray = this.base64ToArrayBuffer(res.data);
              const blobStore = new Blob([bufferArray], { type: 'application/pdf' });
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blobStore);
                return;
              }
              const data = window.URL.createObjectURL(blobStore);
              const link = document.createElement('a');
              document.body.appendChild(link);
              link.href = data;
              link.download = 'Scholar Data Dashboard_' + currentDate;
              link.target = 'blank';
              link.click();
              window.URL.revokeObjectURL(data);
              link.remove();
            }
          });
        });
      }
    }, 3000);
  }

  /* istanbul ignore next */
  base64ToArrayBuffer(data: any) {
    const bString = window.atob(data);
    const bLength = bString.length;
    const bytes = new Uint8Array(bLength);
    for (let i = 0; i < bLength; i++) {
      const ascii = bString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
  showLable(text: string) {
    this.doughnutChartText = text;

  }
  showLabaleRecuriment(text: string) {
    this.doughnutChartTextValue = text;
  }
  getSite(programId: number) {
    getSiteByProgramId(programId).then((res: any) => {
      this.getSiteByProgramIdResponse(res);      
    });
  }

  getSiteByProgramIdResponse(res :any) {
    if (res.status === APP_CONST.RESPONSE_200) {
      const data = res.data;
      if (data) {
        const sitesFill: any = [];
        data.forEach((item: any) => {
          sitesFill.push({ name: item.siteName, id: item.siteId, startDate: item.startDate, endDate: item.endDate });
        });
        this.siteList = sitesFill;
        this.siteOverRole();
      }
    }
    else{
      this.siteOverRole();
    }
  }

  public getScreenText(key: string): string {
    return this.objScreenText.getScreenText(key);
  }

  updateSlicing(type: string, prev: number, next: number, callFrom: string) {
    if (callFrom === 'mobile') {
      this.selectedTab = 'ada';
    }
    this.CheckIfLineAndAda(type, next, prev);
    this.CheckIfBarAndAda(type, next, prev);
    this.CheckIfLineAndRetention(type, next, prev);
    this.CheckIfBarAndRetention(type, next, prev);
    this.slicedChartData(type);
  }
  private CheckIfBarAndRetention(type: string, next: number, prev: number) {
    if (type == 'bar' && this.barChartDataFormat && this.selectedTab == 'retention') {
      if (next && !prev) {
        this.retBarSliceStart++;
        this.retBarSliceEnd++;
      }
      else if (!next && prev) {
        this.retBarSliceStart--;
        this.retBarSliceEnd--;
      }
    }
  }

  private CheckIfLineAndRetention(type: string, next: number, prev: number) {
    if (type == 'line' && this.lineChartDataFormat && this.selectedTab == 'retention') {
      if (next && !prev) {
        this.retLineSliceStart++;
        this.retLineSliceEnd++;
      }
      else if (!next && prev) {
        this.retLineSliceStart--;
        this.retLineSliceEnd--;
      }
    }
  }

  private CheckIfLineAndAda(type: string, next: number, prev: number) {
    if (type == 'line' && this.lineChartDataFormat && this.selectedTab == 'ada') {
      if (next && !prev) {
        this.adaLineSliceStart++;
        this.adaLineSliceEnd++;
      }
      else if (!next && prev) {
        this.adaLineSliceStart--;
        this.adaLineSliceEnd--;
      }
    }
  }

  private CheckIfBarAndAda(type: string, next: number, prev: number) {
    if (type == 'bar' && this.barChartDataFormat && this.selectedTab == 'ada') {
      if (next && !prev) {
        this.adaBarSliceStart++;
        this.adaBarSliceEnd++;
      }
      else if (!next && prev) {
        this.adaBarSliceStart--;
        this.adaBarSliceEnd--;
      }
    }
  }

  mobileupdateSlicing(type: string, prev: number, next: number) {
    if (type == 'line' && this.mobilelineChartDataFormat) {
      if (next && !prev) {
        this.retLineSliceStart++;
        this.retLineSliceEnd++;
      }
      else if (!next && prev) {
        this.retLineSliceStart--;
        this.retLineSliceEnd--;
      }
    }
    if (type == 'bar' && this.mobilebarChartDataFormat) {
      if (next && !prev) {
        this.retBarSliceStart++;
        this.retBarSliceEnd++;
      }
      else if (!next && prev) {
        this.retBarSliceStart--;
        this.retBarSliceEnd--;
      }
    }
    this.mobileslicedChartData(type);
  }

  updateQualitySlicing(prev: number, next: number) {
    if (this.qualityGraphData) {
      if (next && !prev) {
        this.qualityLineSliceStart++;
        this.qualityLineSliceEnd++;
      }
      else if (!next && prev) {
        this.qualityLineSliceStart--;
        this.qualityLineSliceEnd--;
      }
    }
    this.qualityGraphData = this.allQualityGraphData.slice(this.qualityLineSliceStart * 7, this.qualityLineSliceEnd * 7);
  }
 
  evaluatePrev(type: string) {
    if ((this.selectedTab == 'ada' && this.adaLineSliceStart != 0 && type == 'line') || (this.selectedTab == 'ada' && this.adaBarSliceStart != 0 && type == 'bar') || (this.selectedTab == 'retention' && this.retLineSliceStart != 0 && type == 'line') || (this.selectedTab == 'retention' && this.retBarSliceStart != 0 && type == 'bar') || (this.qualityLineSliceStart != 0 && type == 'quality')) {
      return true;
    }

    return false;
  }
  mobileevaluatePrev(type: string) {

    if ((this.retLineSliceStart != 0 && type == 'line') || (this.retBarSliceStart != 0 && type == 'bar')) {
      return true;
    }
    return false;
  }
  mobileevaluatePrevForAda(type: string) {

    if ((this.adaLineSliceStart != 0 && type == 'line') || (this.adaBarSliceStart != 0 && type == 'bar')) {
      return true;
    }
    return false;
  }
  evaluateNext(type: string) {
    if ((this.selectedTab == 'ada' && this.adaLineSliceEnd < this.adaLineTotal && type == 'line') || (this.selectedTab == 'ada' && this.adaBarSliceEnd < this.adaBarTotal && type == 'bar') || (this.selectedTab == 'retention' && this.retLineSliceEnd < this.retLineTotal && type == 'line') || (this.selectedTab == 'retention' && this.retBarSliceEnd < this.retBarTotal && type == 'bar') || (type == 'quality' && this.qualityLineSliceEnd < (this.qualityLineTotal / 7))) {
      return true;
    }
    return false;
  }
  mobileevaluateNextForAda(type: string) {

    if ((this.adaLineSliceEnd < this.adaLineTotal && type == 'line') || (this.adaBarSliceEnd < this.adaBarTotal && type == 'bar')) {
      return true;
    }
    return false;
  }

  mobileevaluateNext(type: string) {

    if ((this.retLineSliceEnd < this.retLineTotal && type == 'line') || this.retBarSliceEnd < this.retBarTotal && type == 'bar') {
      return true;
    }
    return false;
  }

  slicedChartData(type: string) {
    if (type == 'line' && this.lineChartDataFormat && this.selectedTab == 'ada') {
      this.slicedLineChartDataFormat = this.lineChartDataFormat.slice(this.adaLineSliceStart, this.adaLineSliceEnd);
      const len = this.slicedLineChartDataFormat.length;
      this.WeekEndDate = this.slicedLineChartDataFormat[len - 1].endDate;
      if (this.WeekEndDate) {
        this.WeekEndDate = APP_UTILITIES.formatFullYearDate(this.WeekEndDate);
      }
      this.slicedLineChartDataFormat.push({ 'week': '' });
    }
    if (type == 'bar' && this.barChartDataFormat && this.selectedTab == 'ada') {
      this.slicedBarChartDataFormat = this.barChartDataFormat.slice(this.adaBarSliceStart, this.adaBarSliceEnd);
      this.slicedBarChartDataFormat.push({ 'site': '' });
    }
    if (type == 'line' && this.lineChartDataFormat && this.selectedTab == 'retention') {
      this.slicedLineChartDataFormat = this.lineChartDataFormat.slice(this.retLineSliceStart, this.retLineSliceEnd);
      const len = this.slicedLineChartDataFormat.length;
      this.WeekEndDate = this.slicedLineChartDataFormat[len - 1].endDate;
      /* istanbul ignore else */
      if (this.WeekEndDate) {
        this.WeekEndDate = APP_UTILITIES.formatFullYearDate(this.WeekEndDate).toString();
      }

      this.slicedLineChartDataFormat.push({ 'week': '' });

    }
    if (type == 'bar' && this.mobilebarChartDataFormat && this.selectedTab == 'retention') {
      this.slicedBarChartDataFormat = this.barChartDataFormat.slice(this.retBarSliceStart, this.retBarSliceEnd);
      this.slicedBarChartDataFormat.push({ 'site': '' });
    }
  }
  mobileslicedChartData(type: string) {
    if (type == 'line' && this.mobilelineChartDataFormat && this.getWindowWidth()) {
      this.scholarRetentionData = this.mobilelineChartDataFormat.slice(this.retLineSliceStart, this.retLineSliceEnd);
      const len = this.scholarRetentionData.length;
      this.WeekEndDate = this.scholarRetentionData[len - 1].endDate;
      /* istanbul ignore else */
      if (this.WeekEndDate) {
        this.WeekEndDate = APP_UTILITIES.formatFullYearDate(this.WeekEndDate).toString();
      }
      this.scholarRetentionData.push({ 'week': '' });

    }
    if (type == 'bar' && this.mobilebarChartDataFormat && this.getWindowWidth()) {
      this.mobileSlicedBarChartDataFormat = this.mobilebarChartDataFormat.slice(this.retBarSliceStart, this.retBarSliceEnd);
      this.mobileSlicedBarChartDataFormat.push({ 'site': '' });
    }
  }
  recruitmentData(response :any) {
    if (response.status == APP_CONST.RESPONSE_200 && (response.data.toBeRecruitedPercentage || response.data.recruitmentPercentage)) {
      this.doughnutDataFormat = {
        headerData1: response.data.activeScholars,
        headerText1: 'Enrolled',
        headerData2: response.data.toBeRecruitedScholars,
        headerText2: 'To Recruit'
      };

      this.doughnutPercentageFormat = {
        headerData1: response.data.recruitmentPercentage,
        headerText1: 'Enrolled',
        headerData2: response.data.toBeRecruitedPercentage,
        headerText2: 'To Recruit'
      };
      this.dataloaded = APP_CONST.TRUE;
    }
    else {
      this.dataloaded = APP_CONST.FALSE;
    }
  }

  async fetchRecruitmentData() {
    let currentDate: any = new Date();
    currentDate = APP_UTILITIES.formatFullYearDate(currentDate);
    const response = await getRecruitmentData(this.programId, currentDate);
    this.recruitmentData(response);    
  }

  beforeMount() {
    this.mobileView = document.documentElement.clientWidth <= this.windowWidth
      ? true
      : false;
    const userRoles: any = APP_UTILITIES.getCookie('user_role');
    this.userRoles = JSON.parse(userRoles);
    this.programId = this.userRoles[APP_CONST.ZERO].programId;
    this.fetchRecruitmentData();
    const id=this.$route && this.$route.params && Number(this.$route.params.id); 
    if(id){
      this.selectedTab= this.$route.params.tabSelected;
      this.tabSelection(id);
    }    
  }

  async updateRetBarChartData() {
    if (!this.getWindowWidth() && this.selectedTab != 'retention') {
      return;
    }
    if (!this.getWindowWidth() && !this.isSelectionFromMobile) {
      this.barChartDataFormat = [];
      this.slicedBarChartDataFormat = [];
    }
    if (!this.getWindowWidth()) {
      this.barChartMessage = true;
    }
    this.barChartMessageForRet = true;

    this.mobilebarChartDataFormat = [];
    this.mobileSlicedBarChartDataFormat = [];
    const response1 = await getRetentionBySite(this.programId);
    /* istanbul ignore else */
    if (response1.status == APP_CONST.RESPONSE_200 && response1.data) {
      if (!this.getWindowWidth()) {
        this.barChartMessage = false;
      }
      this.barChartMessageForRet = false;
      this.retBarTotal = response1.data.length;
      this.hideBarAnnotation = false;
      for (let i = 0; i < this.retBarTotal; i++) {
        const barChartDataObject: any = {};

        barChartDataObject.site = response1.data[i].siteName;
        barChartDataObject.data = response1.data[i].result;

        /* istanbul ignore if */
        if (!this.barChartMessage && response1.data[i].result) {
          if (!this.getWindowWidth()) {
            this.barChartMessage = false;
          }
          this.barChartMessageForRet = false;
        }
        if (this.getWindowWidth()) {
          this.mobilebarChartDataFormat.push(JSON.parse(JSON.stringify(barChartDataObject)));
        }
        else {
          this.barChartDataFormat.push(barChartDataObject);
        }
      }
      if (this.getWindowWidth()) {
        /* istanbul ignore else */
        if (this.retBarTotal <= 5 && this.retBarTotal > 0) {
          for (let i = 0; i < 5 - this.retBarTotal; i++) {
            const barChartDataObjectEmpty: any = {};

            barChartDataObjectEmpty.site = '';
            this.mobilebarChartDataFormat.push(barChartDataObjectEmpty);
          }
        }
      }
      else {
        /* istanbul ignore else */
        if (this.retBarTotal <= 8 && this.retBarTotal > 0) {
          for (let i = 0; i < 8 - this.retBarTotal; i++) {
            const barChartDataObjectEmpty: any = {};

            barChartDataObjectEmpty.site = '';
            this.barChartDataFormat.push(barChartDataObjectEmpty);
          }
        }
      }
    }
    else if (!response1 || !response1.data) {
      this.hideBarAnnotation = true;
      this.attandancePercentage = '--';
      if (this.getWindowWidth()) {
        this.mobileAttandancePercentage = '--';
      }
    }
    if (this.getWindowWidth()) {
      this.mobileslicedChartData('bar');
    }
    else {
      this.slicedChartData('bar');
    }
  }


  async updateRetLineChartData(obj: any = null) {

    let response: any;
    if (obj != null) {
      response = obj;
    }
    else {
      const selectedId = this.selectedSiteId;
      response = await getRetention(this.programId, selectedId, true);
    }
    if (!this.getWindowWidth() && this.selectedTab != 'retention') {
      return;
    }
    if (!this.getWindowWidth()) {
      this.lineChartDataFormat = [];
    }
    else {
      this.mobilelineChartDataFormat = [];
    }
    if (response.status != APP_CONST.RESPONSE_200 || !response.data || !response.data.dashboardData) {

      this.getWindowWidth()
        ? this.mobileLineChartMessage = true
        : this.lineChartMessage = true;
    }
    /* istanbul ignore else */
    if (response && response.data && response.data.dashboardData) {
      this.retLineTotal = response.data.dashboardData.length;
      if (this.getWindowWidth()) {
        this.mobileAttandancePercentage = response.data.averageResult;
      }
      else {
        this.attandancePercentage = response.data.averageResult;
      }
      this.getWindowWidth()
        ? this.mobileLineChartMessage = true
        : this.lineChartMessage = true;
      for (let i = 0; i < response.data.dashboardData.length; i++) {
        const lineChartDataObject: any = {};
        lineChartDataObject.week = response.data.dashboardData[i].number;
        lineChartDataObject.data = response.data.dashboardData[i].result;
        lineChartDataObject.endDate = response.data.dashboardData[i].endDate;
        if (response.data.dashboardData[i].result) {
          this.getWindowWidth()
            ? this.mobileLineChartMessage = false
            : this.lineChartMessage = false;
        }
        /* istanbul ignore else */
        if (this.getWindowWidth()) {
          this.mobilelineChartDataFormat.push(JSON.parse(JSON.stringify(lineChartDataObject)));
          this.lineChartDataFormat.push(lineChartDataObject);
        }
        else {
          this.lineChartDataFormat.push(lineChartDataObject);
        }

      }
      if (this.getWindowWidth()) {
        if (this.mobileAttandancePercentage) {
          this.mobileAttandancePercentage = this.zeroFixed(this.mobileAttandancePercentage, 2);
          this.mobileAttandancePercentage = this.mobileAttandancePercentage + '%';
          this.hideAnnotation = false;
        }
        else {
          this.hideAnnotation = true;
          this.mobileAttandancePercentage = '--';
        }
      }
      else {
        if (this.attandancePercentage) {
          this.attandancePercentage = this.zeroFixed(this.attandancePercentage, 2);
          this.attandancePercentage = this.attandancePercentage + '%';
          this.hideAnnotation = false;
        }
        else {
          this.hideAnnotation = true;
          this.attandancePercentage = '--';
        }
      }

    }
    else if (!response || !response.data) {
      this.hideAnnotation = true;
      if (!this.getWindowWidth()) {
        this.attandancePercentage = '--';
      }
      this.mobileAttandancePercentage = '--';
    }
    if (!this.getWindowWidth()) {
      this.handleResponse(this.lineChartMessage);
    }
    else {
      this.handleResponse(this.mobileLineChartMessage);
    }
    if (this.getWindowWidth()) {
      this.mobileslicedChartData('line');
    }
    else {
      this.slicedChartData('line');
    }
  }
  handleResponse(check: boolean) {
    if (check) {
      if (this.getWindowWidth()) {
        this.mobilelineChartDataFormat = [{ week: 1 }, { week: 2 }, { week: 3 }, { week: 4 }, { week: 5 }, { week: '' }];
      }
      else {
        this.lineChartDataFormat = [{ week: 1 }, { week: 2 }, { week: 3 }, { week: 4 }, { week: 5 }, { week: 6 }, { week: 7 }, { week: 8 }, { week: '' }];
      }
      this.retLineSliceStart = 0;
      this.retLineSliceEnd = this.getWindowWidth()
        ? 5
        : 8;
      this.retLineTotal = 0;
    }
    else {
      if (this.getWindowWidth()) {
        this.retLineSliceEnd = this.mobilelineChartDataFormat.length;
        if (this.mobilelineChartDataFormat.length <= 5) {
          this.retLineSliceStart = 0;
        }
        else {
          this.retLineSliceStart = this.mobilelineChartDataFormat.length - 5;

        }
      }
      else {
        this.retLineSliceEnd = this.lineChartDataFormat.length;
        if (this.lineChartDataFormat.length <= 8) {
          this.retLineSliceStart = 0;
        }
        else {

          this.retLineSliceStart = this.lineChartDataFormat.length - 8;

        }
      }
    }
  }
  updateBarAdaChartData(response1 :any) {
    if (response1.status == APP_CONST.RESPONSE_200 && response1.data) {
      this.barChartMessage = false;
      this.adaBarTotal = response1.data.length;
      this.hideBarAnnotation = false;
      for (let i = 0; i < this.adaBarTotal; i++) {
        const barChartDataObject: any = {};

        barChartDataObject.site = response1.data[i].siteName;
        barChartDataObject.data = response1.data[i].result;

        /* istanbul ignore else */
        if (!this.barChartMessage && response1.data[i].result) {
          this.barChartMessage = false;
        }

        this.barChartDataFormat.push(barChartDataObject);
      }
      const checkLoopConditon = this.getWindowWidth()
        ? 5
        : 8;
      /* istanbul ignore else */
      if (this.adaBarTotal <= checkLoopConditon && this.adaBarTotal > 0) {
        for (let i = 0; i < checkLoopConditon - this.adaBarTotal; i++) {
          const barChartDataObjectEmpty: any = {};

          barChartDataObjectEmpty.site = '';
          this.barChartDataFormat.push(barChartDataObjectEmpty);
        }
      }
    }
    else if (!response1 || !response1.data) {
      this.hideBarAnnotation = true;
      this.attandancePercentage = '--';
    }

    this.slicedChartData('bar');
  }

  async updateAdaBarChartData() {
    if (this.selectedTab != 'ada') {
      return;
    }

    this.barChartMessage = true;
    this.barChartDataFormat = [];
    this.slicedBarChartDataFormat = [];

    const response1 = await getAdaBySite(this.programId);
    this.updateBarAdaChartData(response1);
  }

  async updateAdaLineChartData(obj: any = null) {
    let response: any;
    if (obj != null) {
      response = obj;
    }
    else {
      /* istanbul ignore else */
      if (this.programId > 0) {
        response = await getAda(this.programId, this.selectedSiteId, true);
      }
    }
    if (this.selectedTab != 'ada') {
      return;
    }
    this.lineChartDataFormat = [];
    if (response.status != APP_CONST.RESPONSE_200 || !response.data || !response.data.dashboardData) {
      this.lineChartMessage = true;
    }
    if (response && response.data && response.data.dashboardData) {
      this.adaLineTotal = response.data.dashboardData.length;
      this.lineChartMessage = true;
      this.attandancePercentage = response.data.averageResult;
      for (let i = 0; i < response.data.dashboardData.length; i++) {
        const lineChartDataObject: any = {};
        lineChartDataObject.week = response.data.dashboardData[i].number;
        lineChartDataObject.data = response.data.dashboardData[i].result;
        lineChartDataObject.endDate = response.data.dashboardData[i].endDate;
        if (response.data.dashboardData[i].result) {
          this.lineChartMessage = false;
        }
        this.lineChartDataFormat.push(lineChartDataObject);
      }
      if (this.attandancePercentage) {
        this.attandancePercentage = this.zeroFixed(this.attandancePercentage, 2);
        this.attandancePercentage = this.attandancePercentage + '%';
        this.hideAnnotation = false;
      }
      else {
        this.hideAnnotation = true;
        this.attandancePercentage = '--';
      }
    }
    else if (!response || !response.data) {
      this.hideAnnotation = true;
      this.attandancePercentage = '--';
    }
    if (this.lineChartMessage) {
      if (this.getWindowWidth()) {
        this.lineChartDataFormat = [{ week: 1 }, { week: 2 }, { week: 3 }, { week: 4 }, { week: 5 }, { week: '' }];
      }
      else {
        this.lineChartDataFormat = [{ week: 1 }, { week: 2 }, { week: 3 }, { week: 4 }, { week: 5 }, { week: 6 }, { week: 7 }, { week: 8 }, { week: '' }];
      }

      this.adaLineSliceStart = 0;
      this.adaLineSliceEnd = this.getWindowWidth()
        ? 5
        : 8;
      this.adaLineTotal = 0;
    }
    else {
      this.adaLineSliceEnd = this.lineChartDataFormat.length;
      const checkLength = this.getWindowWidth()
        ? 5
        : 8;
      if (this.lineChartDataFormat.length <= checkLength) {
        this.adaLineSliceStart = 0;
      }
      else {
        /* istanbul ignore else */
        if (this.getWindowWidth()) {
          this.adaLineSliceStart = this.lineChartDataFormat.length - 5;
        }
        else {
          this.adaLineSliceStart = this.lineChartDataFormat.length - 8;
        }
      }
    }
    this.slicedChartData('line');
  }
  async mobileUpdateChartData() {

    this.scholarRetentionData = [];
    this.lineChartMessage = false;
    this.barChartMessage = false;
    this.lineChartDataFormat = [];
    this.slicedLineChartDataFormat = [];
    this.updateRetLineChartData();
    /* istanbul ignore else */
    if (!this.selectedSiteId) {
      this.updateRetBarChartData();
    }


    this.updateAdaLineChartData();
    /* istanbul ignore else */
    if (!this.selectedSiteId) {
      this.updateAdaBarChartData();
    }

  }
  async updateChartData() {
    const type = this.selectedTab;
    this.lineChartDataFormat = [];
    this.slicedLineChartDataFormat = [];
    this.lineChartMessage = false;
    this.barChartMessage = false;
    this.attandancePercentage = '';
    if (type == 'retention') {
      this.updateRetLineChartData();
      /* istanbul ignore else */
      if (!this.selectedSiteId) {
        this.updateRetBarChartData();
      }
    }
    else if (type == 'ada') {
      this.updateAdaLineChartData();
      if (!this.selectedSiteId) {
        this.updateAdaBarChartData();
      }
    }
  }

  getSelectedTabDetails(id: number) {
    if (id == 0 && this.selectedTab != 'ada') {
      this.selectedTab = 'ada';
      this.tabSelection(id);
    }
    else if (id == 1 && this.selectedTab != 'retention') {
      this.selectedTab = 'retention';
      this.tabSelection(id);
    }
  }

  tabSelection(id: number) {
    this.siteOverRole();
    this.tabs.forEach((tab, index) => {
      if (id === index) {
        tab.active = APP_CONST.TRUE;
        this.TabIndex = index;
      }
      else {
        tab.active = APP_CONST.FALSE;
      }
    });
  }

  selectList(site: { id: number; name: string }) {
    /* istanbul ignore else */
    if (site) {
      this.callHoverOut();
      this.selectedSite = site.name;
      this.selectedSiteId = site.id;
      this.selectedFilterTabForAda = site.id;
      this.openSiteDrop = false;
      this.openRetetionDrop = false;
      this.openADARetetionDrop = false;
      this.isSelectionFromMobile = false;
      this.updateQualityDashboard = false;
      this.updateChartData();
      this.getQualityData(site);
      this.hidequalityScore = true;
    }
  }
  selectListForStaffAndSiteAdmi(site: { id: number; name: string }) {
    /* istanbul ignore else */
    if (site) {
      this.selectedFilterTab = site.id;
      this.mobileSelectedSite = site.name;
      this.openSiteDrop = false;
      this.openRetetionDrop = false;
      this.openADARetetionDrop = false;
      if (this.getWindowWidth()) {
        this.isSelectionFromMobile = true;
      }
      this.scholarRetentionData = [];
      this.updateRetLineChartData();
      if (!this.selectedFilterTab) {
        this.updateRetBarChartData();
      }
    }



  }
  mobileSelectList(site: { id: number; name: string }, type: string) {
    /* istanbul ignore else */
    if (site) {
      this.selectedSiteId = site.id;
      this.selectedSite = site.name;
      this.openSiteDrop = false;
      this.openRetetionDrop = false;
      this.openADARetetionDrop = false;
      this.isSelectionFromMobile = true;
      this.mobileUpdateChartData();
    }
  }

  openSiteDropdown(close?: boolean) {

    const closeStatus = (close
      ? APP_CONST.FALSE
      : APP_CONST.TRUE);
    this.openSiteDrop = this.openSiteDrop
      ? APP_CONST.FALSE
      : closeStatus;
  }
  mobileOpenSiteDropdown(close?: boolean) {
    const closeStatus = (close
      ? APP_CONST.FALSE
      : APP_CONST.TRUE);
    this.openRetetionDrop = this.openRetetionDrop
      ? APP_CONST.FALSE
      : closeStatus;
  }
  mobileADAOpenSiteDropdown(close?: boolean) {
    const closeStatus = (close
      ? APP_CONST.FALSE
      : APP_CONST.TRUE);
    this.openADARetetionDrop = this.openADARetetionDrop
      ? APP_CONST.FALSE
      : closeStatus;
  }

  siteDetails(roleId :number) {
    this.siteSelected = [];
    if (roleId <= APP_CONST.ROLE_TYPE_PROGRAM_ADMIN) {
      this.selectList({ id: 0, name: 'All Sites' });
      if (this.getWindowWidth()) {
        this.selectListForStaffAndSiteAdmi({ id: 0, name: 'All Sites' });
        this.getQualityData({ id: 0, name: 'All Sites' });
      }
    }
    else {
      const rolewiseSite = this.siteList.find((site) => site.id === this.userDetails.siteId);
      const selectedSite = this.siteList.length > 0
        ? rolewiseSite
        : { id: 0, name: 'All Sites' };
      this.selectList(selectedSite);
      /* istanbul ignore else */
      if (this.getWindowWidth()) {
        this.selectListForStaffAndSiteAdmi(selectedSite);
        this.getQualityData(selectedSite);
      }
      if(selectedSite) {
        this.siteData = this.userDetails.sitePanels.filter((item: any) => item.siteId == selectedSite.id);
        this.siteSelected.push(selectedSite);
      }
    }
  }
  siteOverRole() {
    this.siteDetails(this.roleId);   
  }

  getQualityResult(response:any) {
    if (response.status === APP_CONST.RESPONSE_200) {
      this.emptyState = false;
      this.qualityAverageScore = response.data.averageScore;
      let graphsData = response.data.graphsData;
      let result = this.findWeekCount(graphsData, 'weekNumber');
      if (result[Object.keys(result)[0]] < 7) {
        graphsData.unshift(...this.getFirstDayOfWeek(Number(Object.keys(result)[0]), graphsData[0].date));
      }
      /* istanbul ignore else */
      if (result[Object.keys(result).length] < 7) {
        graphsData = [...graphsData, ...this.getLastDayOfWeek(Number(Object.keys(result).length), graphsData[graphsData.length - 1].date)];
      }
      result = this.findWeekCount(graphsData, 'weekNumber');
      let tempData: any = [];
      for (const [key] of Object.entries(result)) {
        const filterData = graphsData.filter((dateObj: any) => dateObj.weekNumber == key);
        tempData.push(...this.createFormateData(filterData));
      }
      if (!this.updateQualityDashboard) {
        this.qualityLineTotal = tempData.length;
        this.qualityLineSliceEnd = this.qualityLineTotal / 7;
        this.qualityLineSliceStart = this.mobileView
          ? this.qualityLineSliceEnd - 3
          : this.qualityLineSliceEnd - 8;
        if (this.qualityLineSliceStart < 0) {
          this.qualityLineSliceStart = 0;
        }
      }
      this.updateQualityDashboard = false;
      tempData = this.createFakeValue(tempData);
      this.qualityGraphData = [...tempData.slice(this.qualityLineSliceStart * 7, this.qualityLineSliceEnd * 7)];
      this.allQualityGraphData = [...tempData];
      this.emptyState = false;
      this.hideQualityAnnotation = false;
      /* istanbul ignore else */
      if (response.data.averageScore === 'N/A') {
        this.emptyState = true;
        this.qualityGraphData = this.mobileView
          ? this.emptyDataMobile
          : this.emptyData;
        this.qualityAverageScore = '--';
        this.hideQualityAnnotation = true;
        this.qualityLineSliceStart = 0;
      }
    }
    if (response.status === APP_CONST.RESPONSE_204) {
      this.emptyState = true;
      this.qualityGraphData = this.mobileView
        ? this.emptyDataMobile
        : this.emptyData;
      this.qualityAverageScore = '--';
      this.hideQualityAnnotation = true;
    }
  }
  async getQualityData(sites: any) {
    const response: any = await getQualityData(this.programId, sites.id);
    this.getQualityResult(response);
  }
  findWeekCount(data: any, prop: any) {
    return data
      .reduce((res: any, item: any) => Object
        .assign(res, {
          [item[prop]]: 1 + (res[item[prop]] || 0)
        }), Object.create(null))
    ;
  }
  findLastIndex(items: any, callback: any) {
    return items.reduce((acc: any, curr: any, index: any) => callback(curr)
      ? index
      : acc, 0);
  }
  createFakeValue(graphData: any) {
   
    const GraphDataWithFakeValues = JSON.parse(JSON.stringify(graphData));
    let no_of_records_without_score = 0;
    const lastScoreValue = [];
    let elementPostion = [];
    const findFirstValue = (element: any) => element.score != 'N/A';
    const lastIndex = this.findLastIndex(GraphDataWithFakeValues, (curr: any) => curr.score != 'N/A');
    const index = graphData.findIndex(findFirstValue);
    /* istanbul ignore next */
    if(index>=0){
      for (let i = index; i <=lastIndex; i++) {
        if (graphData[i].score != 'N/A') {
          if (lastScoreValue.length > 0) {
            const lastScore = lastScoreValue[lastScoreValue.length - 1];
            const diff = Number(graphData[i].score) - Number(lastScore);
            const avg = (diff / (no_of_records_without_score + 1)).toFixed(3);
            if (Number(avg) >= 0) {
              for (let j = 0; j < elementPostion.length; j++) {
                if (j == 0) {
                  const result = parseFloat(lastScore) + parseFloat(avg);
                  GraphDataWithFakeValues[elementPostion[j]].score = result.toFixed(3);
                  GraphDataWithFakeValues[elementPostion[j]].fake = true;
                }
                else {
                  const result = parseFloat(GraphDataWithFakeValues[elementPostion[j] - 1].score) + parseFloat(avg);
                  GraphDataWithFakeValues[elementPostion[j]].score = result.toFixed(3);
                  GraphDataWithFakeValues[elementPostion[j]].fake = true;
                }
              }
            }
            else {
              for (let k = 0; k < elementPostion.length; k++) {
                if (k == 0) {
                  const result = parseFloat(lastScore) - Math.abs(parseFloat(avg));
                  GraphDataWithFakeValues[elementPostion[k]].score = result.toFixed(3);
                  GraphDataWithFakeValues[elementPostion[k]].fake = true;
                }
                else {
                  const result = parseFloat(GraphDataWithFakeValues[elementPostion[k] - 1].score) - Math.abs(parseFloat(avg));
                  GraphDataWithFakeValues[elementPostion[k]].score = result.toFixed(3);
                  GraphDataWithFakeValues[elementPostion[k]].fake = true;
                }
              }
            }
            elementPostion = [];

          }
          lastScoreValue.push(graphData[i].score);
          no_of_records_without_score = 0;
        } 
        /* istanbul ignore else */
        else {
          elementPostion.push(i);
          no_of_records_without_score = no_of_records_without_score + 1;
        }
      }
    }
    return GraphDataWithFakeValues;
  
  }
  createFormateData(filterData: any) {
    const data = [];
    for (let i = 0; i < filterData.length; i++) {
      if (i == 0) {
        data.push({ 'week': filterData[i].weekNumber, 'score': filterData[i].score, 'endDate': filterData[i].date, 'count': filterData[i].count, fake: false });
      }
      else {
        data.push({ 'week': Number(filterData[i].weekNumber + '.' + Number(i + 1)), 'score': filterData[i].score, 'endDate': filterData[i].date, 'count': filterData[i].count, fake: false });
      }
    }
    return data;


  }

  getFirstDayOfWeek(weekNumber: number, date: any) {
    const today = new Date(date);
    const oneDay = 24 * 60 * 60 * 1000;
    const firstDate: any = new Date(new Date(today.setDate(today.getDate() - today.getDay())));
    const secondDate: any = new Date(date);
    const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
    const data = [];
    for (let j = 1; j <= diffDays; j++) {
      const secondDate1: any = new Date(date);
      data.push({ 'weekNumber': weekNumber, 'score': 'N/A', 'date': APP_UTILITIES.formatCorrectDate(new Date(secondDate1.setDate(secondDate1.getDate() - j)).toDateString()) });
    }
    return data.reverse();

  }

  getLastDayOfWeek(weekNumber: number, date: any) {
    const today = new Date(date);
    const oneDay = 24 * 60 * 60 * 1000;
    const firstDate: any = new Date(date);
    const secondDate: any = new Date(new Date(today.setDate(today.getDate() - (today.getDay() - 1) + 5)));
    const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
    const data = [];
    for (let j = 1; j <= diffDays; j++) {
      const secondDate1: any = new Date(date);
      data.push({ 'weekNumber': weekNumber, 'score': 'N/A', 'date': APP_UTILITIES.formatCorrectDate(new Date(secondDate1.setDate(secondDate1.getDate() + j)).toDateString()) });
    }
    return data;

  }
  async getAssementQualityData(week: number) {
    const filterData = this.allQualityGraphData.filter((dateObj: any) => dateObj.week == week);

    const response: any = await getAssementQualityData(this.programId, this.selectedSiteId, filterData[0].endDate);
    /* istanbul ignore else */
    if (response.status === APP_CONST.RESPONSE_200) {
      this.hidequalityScore = false;
      const openEditPopup: any = this.$refs.sidepanelDesktop;
      openEditPopup.editModeFromGraph(response.data, week);
      /* istanbul ignore else */
      if (this.mobileView) {
        this.openSidepanel();
      }
    }
  }

  formateDate(date: any) {
    if (!date) {
      return date;
    }
    return APP_UTILITIES.formatDate(date);
  }

  zeroFixed(x: any, d: number) {
    if (!d) {
      return x.toFixed(d);
    }
    return x.toFixed(d).replace(/\.?0+$/, '');
  }
  debounce(func: any) {
    let timer: any;
    return function (event: any) {
      /* istanbul ignore if */
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(func, 200, event);
    };
  }
  getWidth(width : any) {
    if (width <= 768) {

      return true;
    }
    else {
      this.styles = {
        width: '100%',
        height: '325px',
        position: 'relative'
      };
    }
    return false;
  }
  getWindowWidth() {
    return this.getWidth(document.documentElement.clientWidth);
  }
  resetData() {
    this.selectedTab = 'ada';
    this.selectedSiteId = APP_UTILITIES.mobileAndTabletCheck()
      ? this.selectedSiteId
      : 0;
    this.selectedFilterTab = 0;
    this.selectedFilterTabForAda = 0;
    this.selectedSite = APP_UTILITIES.mobileAndTabletCheck()
      ? this.selectedSite
      : 'All Sites';
    this.isSelectionFromMobile = false;
    this.retLineSliceStart = 0;
    this.retLineSliceEnd = this.getWindowWidth()
      ? 5
      : 8;
    this.retBarSliceStart = 0;
    this.retBarSliceEnd = this.getWindowWidth()
      ? 5
      : 8;
    this.adaLineSliceStart = 0;
    this.adaLineSliceEnd = this.getWindowWidth()
      ? 5
      : 8;
    this.adaBarSliceStart = 0;
    this.adaBarSliceEnd = this.getWindowWidth()
      ? 5
      : 8;
    this.adaBarTotal = 0;
    this.qualityGraphData = [];
    this.adaLineTotal = 0;
    this.retLineTotal = 0;
    this.retBarTotal = 0;
    this.doughnutChartText = 'Enrolled';
    this.doughnutChartTextValue = 'Enrolled';
    this.fetchRecruitmentData();
    /* istanbul ignore else */
    if(!APP_UTILITIES.mobileAndTabletCheck()){
      this.siteOverRole();
    }
    this.qualityLineSliceEnd = this.getWindowWidth()
      ? 3
      : 8;
    this.getQualityData({ id: this.selectedSiteId });
    const tooltipId: any = document.getElementById('chartjs-tooltip');
    if (tooltipId) {
      tooltipId.style.opacity = 0;
    }
    const tooltipIdBar: any = document.getElementById('chartjs-tooltip-bar');
    if (tooltipIdBar) {
      tooltipIdBar.style.opacity = 0;
    }
  }
  isMobile(type: any) {
    const checkWidth = document.documentElement.clientWidth <= this.windowWidth
      ? true
      : false;
    if (document.documentElement.clientWidth < 354) {
      this.MobiledoughnutStyle = {
        width: '110px',
        height: '110px',
        margin: '0 auto'
      };
    }
    if (document.documentElement.clientWidth > 354 && document.documentElement.clientWidth <= this.windowWidth) {
      this.MobiledoughnutStyle = {
        width: '116px',
        height: '116px',
        margin: '0 auto'
      };
    }
    if (document.documentElement.clientWidth <= this.windowWidth) {

      this.styles = {
        width: '100%',
        height: '260px',
        position: 'relative'
      };
    }
    if (this.mobileView != checkWidth) {

      this.mobileView = checkWidth;
      this.styles = {
        width: '100%',
        height: '260px',
        position: 'relative'
      };

      this.resetData();

    }
    if (document.documentElement.clientWidth > this.windowWidth) {
      this.styles = {
        width: '100%',
        height: '325px',
        position: 'relative'
      };
    }
  }

  mounted() {
    this.isMobile('');
    window.addEventListener('resize', this.debounce(this.isMobile));
    this.scholarGraph = localStorage.getItem('dashboard_tab_active')=='quality'
      ? false
      :true;
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.isMobile);
  }

  callHover(hoverText: string, $event: any) {
    /* istanbul ignore else */
    if ($event.target.offsetWidth < $event.target.scrollWidth) {
      this.hover = true;
      this.hoverIndex = hoverText;
      const boundBox = $event.target.getBoundingClientRect();
      const coordX = boundBox.left;
      const coordY = boundBox.top;
      this.hoverStyleObj = {
        top: (coordY + 40).toString() + 'px',
        left: (coordX + 50).toString() + 'px'
      };
    }
  }
  callHoverOut() {
    this.hover = false;
  }

  openSidepanel() {
    UIkit.offcanvas('#left-sidepanel').show();
  }

  showGraphInfo(selectedTab: string) {
    this.activeLeftPanelTab = selectedTab;
    if (selectedTab == 'scholar') {
      this.scholarGraph = true;
    }
    else {
      this.scholarGraph = false;
    }
    this.closeSidepanel();
    this.siteOverRole();
  }

  closeSidepanel() {
    if (UIkit.offcanvas('#left-sidepanel')) {
      UIkit.offcanvas('#left-sidepanel').hide();
    }
  }

  updateGraphQuality(scoreDataUpdated: any, week: number, averageScore: number) {
    this.updateQualityDashboard = true;
    if (scoreDataUpdated.siteId == this.selectedSiteId) {
      this.getQualityData({ id: this.selectedSiteId });
    }
    else if (this.selectedSiteId == 0) {
      this.getQualityData({ id: 0, name: 'All Sites' });
    }
  }

  async downloadQualityDataPdf() {
    const breakHieght = 875;
    const scale = 1;
    const threshold = 99;
    const width = 0;
    this.isPdfPrintInProgress = true;
    const dateObj = new Date();
    let currentDate = APP_UTILITIES.getSlashedDates(dateObj);
    currentDate = currentDate.replace(/-/g, '_');
    await Printutility.getPrintView('PrintLineChartQualityData', breakHieght, width, scale, 'Quality Data Dashboard_' + currentDate, '', threshold, true, true);
    this.isPdfPrintInProgress = false;
  }

  destroyed(){
    LocalStorage.deleteFromLocalStorage('dashboard_tab_active');
  }
}